// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher_switcher__lTNjk","button":"switcher_button__QLK7x","active":"switcher_active__w4vbu","isLoading":"switcher_isLoading__q03Ut","shine":"switcher_shine__u1OcM"};